import PropTypes from 'prop-types';

import { Button } from '@hivebrite/design-system/Button';

const buttonText = (payLaterEnabled) => {
  if (payLaterEnabled) {
    return s__('donations|Pay Now');
  }

  return s__('donations|Proceed to payment');
};

const SubmitButton = ({ disabled = false, payLaterEnabled }) => (
  <div className="text--center">
    <Button type="submit" dataTestId="donations-submit" isDisabled={disabled}>
      {buttonText(payLaterEnabled)}
    </Button>
  </div>
);

SubmitButton.propTypes = {
  disabled: PropTypes.bool,
  payLaterEnabled: PropTypes.bool,
};

export default SubmitButton;
